<template>
    <div class="ficha-layout-container">
        <div v-if="!isDataLoaded" class="d-flex justify-content-center align-items-center" style="min-height: calc(100vh - 60px); background: white;">
            <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
                <span class="sr-only">Cargando...</span>
            </div>
        </div>
        <div v-else>
            <div class="fichaHeader">
                <div class="medical-record-header">
                    <div class="patient-profile">
                        <div class="patient-avatar d-none d-md-flex" v-if="typeof GetMedicoFichaActive.cliente !== 'undefined'" :style="getAvatarStyle()">
                            <span>{{ getInitials(GetMedicoFichaActive.cliente.nombre_mostrar) }}</span>
                        </div>
                        <div class="patient-info">
                            <div class="record-type-badge" :style="'background-color: ' + color + '22; color: ' + color">
                                <i class="fas fa-stethoscope mr-1"></i> {{title}}
                            </div>
                            <h2 class="patient-name">
                                <span v-if="typeof GetMedicoFichaActive.cliente !== 'undefined'">
                                    {{formatName(GetMedicoFichaActive.cliente.nombre_mostrar)}}
                                </span>
                                <router-link 
                                    v-if="typeof GetMedicoFichaActive.cliente !== 'undefined'"
                                    :to="'/client/' + GetMedicoFichaActive.cliente.id" 
                                    class="edit-link">
                                    <i class="fa-solid fa-pen-to-square"></i>
                                </router-link>
                            </h2>
                            <div class="patient-meta">
                                <div v-if="GetClienteMetada && GetClienteMetada.datos_paciente && GetClienteMetada.datos_paciente.fecha_nacimiento" class="meta-item">
                                    <i class="fas fa-birthday-cake"></i> {{formatAge(GetClienteMetada.datos_paciente.fecha_nacimiento)}}
                                </div>
                                <div v-if="GetClienteMetada && GetClienteMetada.datos_paciente && GetClienteMetada.datos_paciente.genero" class="meta-item">
                                    <i :class="GetClienteMetada.datos_paciente.genero === 'Macho' ? 'fas fa-mars' : 'fas fa-venus'"></i> 
                                    {{GetClienteMetada.datos_paciente.genero}}
                                </div>
                            </div>
                        </div>
                        
                        <!-- Sections button for mobile -->
                        <div class="mobile-menu-actions d-md-none">
                            <button class="btn-icon" @click="hanlderFoptions">
                                <i class="fas fa-th-list"></i>
                            </button>
                        </div>
                    </div>
                    
                    <div class="medical-alerts d-none d-md-flex">
                        <div class="alert-card" :class="GetClienteMetada && GetClienteMetada.datos_paciente && GetClienteMetada.datos_paciente.tipo_sangre ? 'has-data blood-type-data' : 'no-data'">
                            <div class="alert-icon">
                                <i class="fas fa-tint" :style="GetClienteMetada && GetClienteMetada.datos_paciente && GetClienteMetada.datos_paciente.tipo_sangre ? 'color: #f44336' : ''"></i>
                            </div>
                            <div class="alert-content">
                                <div class="alert-title">Tipo de sangre</div>
                                <div class="alert-value" v-if="GetClienteMetada && GetClienteMetada.datos_paciente && GetClienteMetada.datos_paciente.tipo_sangre">
                                    {{GetClienteMetada.datos_paciente.tipo_sangre}}
                                </div>
                                <div class="alert-value no-data" v-else>
                                    No registrado
                                </div>
                            </div>
                        </div>
                        
                        <div class="alert-card" :class="GetClienteMetada && GetClienteMetada.datos_paciente && GetClienteMetada.datos_paciente.alergias_observaciones ? 'has-data alert-warning' : 'no-data alert-primary'">
                            <div class="alert-icon">
                                <i v-if="GetClienteMetada && GetClienteMetada.datos_paciente && GetClienteMetada.datos_paciente.alergias_observaciones" class="fas fa-allergies"></i>
                                <i v-else class="fas fa-smile"></i>
                            </div>
                            <div class="alert-content">
                                <div class="alert-title">Alergias</div>
                                <div class="alert-value" v-if="GetClienteMetada && GetClienteMetada.datos_paciente && GetClienteMetada.datos_paciente.alergias_observaciones">
                                    Presente
                                </div>
                                <div class="alert-value no-data" v-else>
                                    Sin alergias
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <!-- Compact medical alerts for mobile - completely hide in mobile -->
                    <div class="medical-alerts-compact d-none">
                        <div v-if="GetClienteMetada && GetClienteMetada.datos_paciente && GetClienteMetada.datos_paciente.tipo_sangre" class="compact-alert blood-type">
                            <i class="fas fa-tint"></i> {{GetClienteMetada.datos_paciente.tipo_sangre}}
                        </div>
                        <div v-if="GetClienteMetada && GetClienteMetada.datos_paciente && GetClienteMetada.datos_paciente.alergias_observaciones" class="compact-alert allergies">
                            <i class="fas fa-allergies"></i>
                        </div>
                    </div>
                </div>
                
                <div class="mobile-sections-wrapper d-md-none">
                    <div v-if="fOptions" class="sections-dropdown">
                        <h5 class="sections-title">Secciones</h5>
                        <div class="sections-list">
                            <div v-for="(tab, slug) in tabs" 
                                :key="'tab_' + slug" 
                                @click="changeTab(slug)" 
                                class="section-item" 
                                :class="{'active': tabActive === slug}">
                                <i :class="tab.icon" :style="(tabActive === slug) ? 'color: ' + color : ''"></i>
                                <span>{{tab.name}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="fichaTabBar m-0 d-none d-md-flex">
                    <div v-for="(tab, slug) in tabs" :key="'tab_' + slug" @click="changeTab(slug)" class="fichaTab" :class="{ 'active': tabActive === slug }" :style="(tabActive === slug) ? 'color: ' + color : ''">
                        <div class="tab-content">
                            <i :class="tab.icon"></i>
                            <span class="tab-label">{{tab.name}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="fichaContentTab">
                <template v-for="(tab, slug) in tabs" >
                    <div v-if="tabActive === slug" :key="'tabcontent_' + slug" >
                        <slot :name="slug"></slot>
                    </div>
                </template>
            </div>
        </div>
        
        <Timeline v-if="showTimeline" @close="showTimeline = false" />
    </div>
</template>
<script>
import {mapActions, mapGetters} from "vuex";
import '@vueform/slider/themes/default.css';


// componentes
import Timeline from './Timeline.vue';

export default {
    components: {
        Timeline
    },
    props: [
        'title',
        'color',
        'tabs',
        'tabDefault',
        'enableTimeline',
    ],
    data() {
        return {
            tabActive: '',
            showTimeline: false,
            fOptions: false,
            isMobile: false
        };
    },
    computed: {
        ...mapGetters({
            AuthGetUserInfo: 'AuthGetUserInfo',
            GetMedicoFichaActive: 'GetMedicoFichaActive',
            GetClienteMetada: 'GetClienteMetada'
        }),
        isDataLoaded() {
            return this.GetMedicoFichaActive && 
                   this.GetMedicoFichaActive.cliente && 
                   this.GetMedicoFichaActive.cliente.nombre_mostrar &&
                   this.GetClienteMetada
        }
    },
    mounted() {
        this.tabActive = this.tabDefault;
        
        // Add scroll event listener to enhance tab visibility
        window.addEventListener('scroll', this.handleScroll);
        
        // Check if mobile view
        this.checkIfMobile();
        window.addEventListener('resize', this.checkIfMobile);
        
        // Close dropdown when clicking outside
        document.addEventListener('click', this.handleClickOutside);
    },
    beforeUnmount() {
        // Remove event listeners when component is destroyed
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.checkIfMobile);
        document.removeEventListener('click', this.handleClickOutside);
    },
    methods: {
        ...mapActions({
            FetchClienteMetadaBySlug: 'FetchClienteMetadaBySlug'
        }),
        handleScroll() {
            const tabBar = document.querySelector('.fichaTabBar');
            if (!tabBar) return;
            
            if (window.scrollY > 100) {
                tabBar.classList.add('scrolled');
            } else {
                tabBar.classList.remove('scrolled');
            }
        },
        changeTab(slug) {
            this.tabActive = slug;
            this.emitter.emit("save-default-tab", slug);
            this.emitter.emit("medico-ficha-changed-tab", slug);
            
            // Close the sections dropdown after selection on mobile
            if (this.isMobile) {
                this.fOptions = false;
            }
        },
        formatName(nombre) {
            if (!nombre) return '';  // Si el nombre es null o undefined, retornamos string vacío
            const palabras = nombre.split(" ");
            const nombreFormateado = palabras.map((palabra) => palabra && palabra[0].toUpperCase() + palabra.slice(1).toLowerCase()).join(" ");
            return nombreFormateado;
        },
        getInitials(nombre) {
            if (!nombre) return '';
            return nombre.split(' ')
                .map(word => word[0])
                .join('')
                .toUpperCase()
                .substring(0, 2);
        },
        formatAge(fecha) {
            if (!fecha) return '';
            const birthDate = new Date(fecha);
            const today = new Date();
            let age = today.getFullYear() - birthDate.getFullYear();
            const m = today.getMonth() - birthDate.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }
            return age + ' años';
        },
        hanlderFoptions() {
            this.fOptions = !this.fOptions;
        },
        checkIfMobile() {
            this.isMobile = window.innerWidth < 768;
        },
        handleClickOutside(event) {
            // Close dropdown when clicking outside
            const dropdown = document.querySelector('.sections-dropdown');
            const button = document.querySelector('.btn-icon');
            
            if (this.fOptions && dropdown && button && 
                !dropdown.contains(event.target) && 
                !button.contains(event.target)) {
                this.fOptions = false;
            }
        },
        getAvatarStyle() {
            // Verificar si hay un color en la reserva
            if (this.GetMedicoFichaActive && 
                this.GetMedicoFichaActive.reserva && 
                this.GetMedicoFichaActive.reserva.color &&
                this.GetMedicoFichaActive.reserva.color.trim() !== '') {
                return {
                    'background-color': this.GetMedicoFichaActive.reserva.color
                };
            }
            
            // Color por defecto si no hay color en la reserva
            return {
                'background-color': '#8d8d8d'
            };
        }
    },
};

</script>

<style scoped>
.ficha-layout-container {
    position: relative;
}

.fichaHeader {
    background: white;
    box-shadow: 0 1px 3px rgba(0,0,0,0.03);
    margin-bottom: 0;
    overflow: visible;
    position: sticky;
    top: 0;
}

.medical-record-header {
    padding: 10px 15px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    border-bottom: none;
}

.patient-profile {
    display: flex;
    align-items: center;
    gap: 10px;
    position: relative;
}

.patient-avatar {
    width: 45px;
    height: 45px;
    border-radius: 50%;
    background: #b9b9b9 !important;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-weight: bold;
    color: white;
    box-shadow: 0 2px 6px rgba(0,0,0,0.06);
}

.patient-info {
    display: flex;
    flex-direction: column;
}

.record-type-badge {
    display: inline-block;
    padding: 3px 8px;
    border-radius: 20px;
    font-size: 10px;
    font-weight: 600;
    margin-bottom: 4px;
}

.patient-name {
    font-size: 18px;
    font-weight: bold;
    margin: 0 0 2px 0;
    display: flex;
    align-items: center;
    gap: 8px;
}

.edit-link {
    color: #ccc;
    font-size: 12px;
    transition: color 0.2s;
}

.edit-link:hover {
    color: #666;
}

.patient-meta {
    display: flex;
    gap: 10px;
    color: #666;
    font-size: 12px;
}

.meta-item {
    display: flex;
    align-items: center;
    gap: 4px;
}

.mobile-menu-actions {
    margin-left: auto;
    display: flex;
    align-items: center;
    position: relative;
}

.btn-icon {
    width: 34px;
    height: 34px;
    border-radius: 4px;
    background: #2196f3;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 16px;
    cursor: pointer;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.medical-alerts {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}

.medical-alerts-compact {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 5px;
    justify-content: flex-start;
}

.compact-alert {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 11px;
    padding: 3px 6px;
    border-radius: 4px;
    color: white;
}

.compact-alert i {
    font-size: 10px;
}

.compact-alert.blood-type {
    background-color: #2196f3;
}

.compact-alert.allergies {
    background-color: #ff9800;
}

.alert-card {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 10px;
    border-radius: 6px;
    background: #f9f9f9;
    min-width: 130px;
    transition: all 0.3s ease;
}

.alert-card.has-data {
    background: #e8f4fe;
    border-left: 3px solid #2196f3;
}

.alert-card.blood-type-data {
    background: #ffebee;
    border-left: 3px solid #f44336;
}

.blood-type-data .alert-icon {
    color: #f44336;
}

.alert-card.alert-warning {
    background: #fff8e1;
    border-left: 3px solid #ffc107;
}

.alert-card.alert-primary {
    background: #e8f4fe;
    border-left: 3px solid #2196f3;
}

.alert-icon {
    font-size: 14px;
    color: #999;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: rgba(255,255,255,0.8);
    display: flex;
    align-items: center;
    justify-content: center;
}

.has-data .alert-icon {
    color: #2196f3;
}

.alert-warning .alert-icon {
    color: #ffc107;
}

.alert-primary .alert-icon {
    color: #2196f3;
}

.alert-content {
    display: flex;
    flex-direction: column;
}

.alert-title {
    font-size: 9px;
    text-transform: uppercase;
    font-weight: 600;
    color: #666;
    letter-spacing: 0.5px;
}

.alert-value {
    font-size: 12px;
    font-weight: 500;
}

.alert-value.no-data {
    color: #999;
    font-style: italic;
}

.mobile-sections-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    margin-top: 0;
}

.btn-sections {
    padding: 8px 15px;
    background-color: #09b3af;
    border: none;
    border-radius: 4px;
    color: white;
    font-size: 14px;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 300px;
}

.btn-sections i {
    font-size: 16px;
}

.sections-dropdown {
    position: absolute;
    top: 100%;
    right: 0;
    background: white;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0,0,0,0.15);
    padding: 15px;
    min-width: 250px;
    max-width: 300px;
    width: calc(100vw - 30px);
    z-index: 2;
    margin-top: 10px;
}

.sections-title {
    font-size: 14px;
    margin: 0 0 12px 0;
    font-weight: 600;
    color: #09b3af;
    text-align: center;
}

.sections-list {
    display: flex;
    flex-direction: column;
    max-height: 400px;
    overflow-y: auto;
}

.section-item {
    padding: 10px 12px;
    border-radius: 6px;
    cursor: pointer;
    margin-bottom: 5px;
    transition: all 0.2s;
    font-size: 14px;
    display: flex;
    align-items: center;
    color: #667;
}

.section-item i {
    width: 24px;
    margin-right: 10px;
    text-align: center;
    font-size: 16px;
    color: #aaa;
}

.section-item:hover {
    background: #f5f5f5;
}

.section-item.active {
    background: #f0f7ff;
    font-weight: 500;
}

.section-item.active i {
    color: #09b3af;
}

.section-item.active span {
    color: #09b3af;
}

.fichaTabBar {
    display: flex;
    background: white;
    padding: 0;
    position: relative;
    top: 0;
    overflow-x: auto;
    white-space: nowrap;
    scrollbar-width: none;
    box-shadow: 0 1px 2px rgba(0,0,0,0.01);
    border-radius: 0;
    margin: 0;
    transition: box-shadow 0.3s ease;
    border-top: 1px solid #f8f8f8;
    border-bottom: 1px solid #f8f8f8;
    height: auto;
    min-height: 38px;
}

.fichaTabBar.scrolled {
    box-shadow: 0 1px 3px rgba(0,0,0,0.03);
}

.fichaTab {
    padding: 6px 8px;
    cursor: pointer;
    font-weight: 500;
    color: #666;
    transition: all 0.2s;
    position: relative;
    text-align: center;
    flex-shrink: 0;
    font-size: 11px;
    letter-spacing: 0px;
    border-radius: 0;
    overflow: hidden;
    min-width: 80px;
    background-color: transparent;
    border-right: 1px solid #eaeaea;
    display: flex;
    align-items: center;
    justify-content: center;
}

.fichaTab:last-child {
    border-right: none;
}

.fichaTab.active {
    background: white;
    font-weight: 600;
    color: #555;
    box-shadow: none;
    border-bottom: 2px solid #aaa;
}

.tab-content {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 3px;
    position: relative;
    width: 100%;
}

.fichaTab i {
    font-size: 12px;
    color: #777;
}

.tab-label {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    transition: all 0.2s;
    font-size: 10px;
    max-width: 80px;
}

.fichaTab:hover .tab-label {
    transform: none;
}

.fichaTab:hover {
    color: #444;
    background: rgba(0,0,0,0.02);
}

.fichaTab.active i {
    color: #555;
}


.fichaContentTab {
    padding: 25px;
    background: white;
    border-radius: 0 0 8px 8px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.03);
    margin-top: 0;
    position: relative;
    }

@media (min-width: 992px) {
    .fichaTabBar {
        overflow-x: visible;
        white-space: normal;
        display: flex;
        justify-content: space-between;
        flex-wrap: nowrap;
        width: 100%;
        padding: 0 3px;
        background-color: white;
        min-height: 45px;
    }
    
    .fichaTab {
        flex: 1 1 0;
        text-align: center;
        min-width: unset !important;
        padding: 6px 2px;
        margin: 2px 1px;
        border-radius: 0;
        border-right: none;
        box-shadow: none;
        background-color: transparent;
    }
    
    .fichaTab:hover {
        transform: none;
        box-shadow: none;
        background-color: rgba(0,0,0,0.02);
    }
    
    .fichaTab.active {
        transform: none;
        box-shadow: none;
        background-color: white;
        border-bottom: 2px solid #aaa;
    }
    
    .active-indicator {
        display: block;
        height: 2px;
    }
}

@media (max-width: 768px) {
    .medical-record-header {
        flex-direction: column;
        align-items: flex-start;
        padding: 10px 12px;
    }
    
    .patient-profile {
        width: 100%;
        margin-bottom: 5px;
    }
    
    .patient-avatar {
        display: none;
    }
    
    .patient-name {
        font-size: 16px;
    }
    
    .patient-info {
        max-width: 100%;
    }
    
    .record-type-badge {
        font-size: 9px;
        padding: 2px 6px;
    }
    
    .medical-alerts {
        width: 100%;
        justify-content: space-between;
        margin-bottom: 5px;
    }
    
    .alert-card {
        flex: 1;
        min-width: 120px;
    }
    
    .sections-dropdown {
        position: absolute;
        top: 100%;
        right: 0;
        transform: none;
        width: calc(100vw - 30px);
        max-width: 300px;
        margin-top: 10px;
        border-radius: 10px;
        box-shadow: 0 5px 25px rgba(0,0,0,0.2);
        z-index: 2;
    }
    
    .fichaContentTab {
        padding: 15px;
    }
    
    .medical-alerts-compact {
        display: none;
    }
}

@media (max-width: 991px) {
    .fichaTabBar {
        overflow-x: auto;
        justify-content: flex-start;
        position: sticky;
        top: 0;
        background-color: white;
        height: auto;
        min-height: 36px;
    }
    
    .tab-content {
        justify-content: flex-start;
        gap: 2px;
    }
    
    .fichaTab {
        background-color: transparent;
        border: none;
        border-right: 1px solid #eaeaea;
        margin: 2px 0;
        min-width: 70px;
        padding: 4px 6px;
    }
    
    .fichaTab:hover {
        background-color: rgba(0,0,0,0.02);
    }
    
    .fichaTab.active {
        background-color: white;
        box-shadow: none;
    }
}

.debug-tabs .fichaTab {
    border: 1px dashed rgba(0,0,0,0.1);
}

@media (min-width: 992px) and (max-width: 1100px) {
    .tab-content {
        flex-direction: column;
        gap: 2px;
    }
    
    .fichaTab {
        padding: 6px 3px;
    }
}

.fichaTabBar::-webkit-scrollbar {
    display: none;
}
</style>
